import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { parcelStatusInfo } from '@/parcels/constants'

import { parcelStatusVariants, stylesByVariant } from './constants'
import * as Styles from './styles'

const ParcelStatus = ({ status, variant = parcelStatusVariants.cards }) => {
  const { t } = useTranslation()
  const variantStyles = stylesByVariant[variant]

  const shipmentStatus = parcelStatusInfo[status]

  if (!shipmentStatus) return null

  return (
    <Styles.Container backgroundColor={shipmentStatus.backgroundColor} variant={variant}>
      <shipmentStatus.Icon size={variantStyles.iconSize} color={shipmentStatus.color} />
      <Text type={variantStyles.textStyle} color={shipmentStatus.color}>
        {t(shipmentStatus.label)}
      </Text>
    </Styles.Container>
  )
}

export default ParcelStatus
